import React from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../utils/animationVariants';
import ProductList from '../components/ProductList';
import {
  human_products_with_slug as human_products,
  categories,
  IMAGE_BASE_PATH,
} from '../assets/data/human_prod';

function Human() {
  // console.log(categories);
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <ProductList
        products={human_products.map((product) => ({
          ...product,
          image: `${IMAGE_BASE_PATH}${product.image}`,
        }))}
        basePath="human"
        categories={categories} // categories prop 전달
      />
    </motion.div>
  );
}

export default Human;
